import * as RadixSwitch from '@radix-ui/react-switch'
import React from 'react'
import * as styles from './switch.css.ts'

type SwitchProps = {
  checked: boolean
  onCheckedChange: (checked: boolean) => unknown
  disabled?: boolean
  'aria-label'?: string
}

export const Switch: React.FC<SwitchProps> = ({ checked, onCheckedChange, disabled, 'aria-label': ariaLabel }) => {
  return (
    <RadixSwitch.Root
      className={styles.switchRoot}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <RadixSwitch.Thumb className={styles.switchThumb} />
    </RadixSwitch.Root>
  )
}
